import * as React from 'react'

const IconLearner = (props) => {
  const { color } = props
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='icon-learner_svg__a' d='M0 0h42.452v39H0z' />
      </defs>
      <g transform='translate(3 5)' fill='none' fillRule='evenodd'>
        <mask id='icon-learner_svg__b' fill='#fff'>
          <use xlinkHref='#icon-learner_svg__a' />
        </mask>
        <path
          d='M23 31.969v-9.97a1 1 0 0 0-1.187-.981l-8.977 1.71a32.41 32.41 0 0 1 2.621-5.22c1.005.896 2.845 1.999 5.802 1.999.058 0 .11-.007.168-.008.054 0 .106.008.16.008a9.617 9.617 0 0 0 4.187-.975c.284-.131.552-.268.793-.407.064-.037.121-.074.183-.111.115-.072.232-.141.345-.218.203-.136.392-.27.555-.396 2.238 3.54 3.459 7.146 4.114 9.682l-4.434 4.433c-1.248.223-2.697.39-4.33.454zm-10.5.812v-7.953l8.5-1.62v11.965l-8.5 1.619V32.78zM2 23.209l8.001 1.524.499.095v11.964L2 35.172V23.21zM13.834 9.754C13.834 5.478 17.312 2 21.587 2c4.276 0 7.754 3.478 7.754 7.754a7.746 7.746 0 0 1-3.347 6.372 7.492 7.492 0 0 1-.285.183c-.063.04-.127.079-.192.117-.944.535-2.32 1.045-4.121 1.07-4.186-.101-7.562-3.531-7.562-7.742zm25.723 12.363a.223.223 0 0 1 .312-.001l.519.52a.22.22 0 0 1 0 .31l-.57.57-.83-.83.569-.57zm-5.382 7.043-3.669 3.669-.751.75-.44-.44-.391-.39 2.213-2.213.933-.933 1.905-1.904 3.599-3.6.83.832-4.229 4.229zm-5.743 4.912.088-.313.225.226-.313.087zm13.37-12.851-.519-.52a2.225 2.225 0 0 0-3.14 0l-1.276 1.278-3.475 3.474c-.777-2.666-2.098-6.122-4.291-9.487a9.708 9.708 0 0 0 2.24-6.212C31.341 4.376 26.966 0 21.587 0c-5.378 0-9.753 4.376-9.753 9.754 0 2.359.842 4.524 2.241 6.212-1.525 2.339-2.63 4.722-3.422 6.855l-9.466-1.803A1 1 0 0 0 0 22v14a1 1 0 0 0 .813.983l10.5 2a1.066 1.066 0 0 0 .374 0l10.5-2A1 1 0 0 0 23 36v-2.031a34.95 34.95 0 0 0 3.467-.296l-.441 1.572a1 1 0 0 0 1.233 1.233l3.119-.874a1.01 1.01 0 0 0 .437-.256l9.709-9.71h.002l.001-.002 1.275-1.275a2.222 2.222 0 0 0 0-3.14z'
          fill={color || '#262626'}
          mask='url(#icon-learner_svg__b)'
        />
      </g>
    </svg>
  )
}

export default IconLearner
